import React, { Fragment, memo, useEffect, useRef, useState, useCallback } from "react";
import "../assets/css/dates.css";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { useStoreFly } from "../store";
import { LookupItems } from "./common/LookupItems";
import GroupedAirportSearch from "./common/GroupedAirportSearch";
import { useFilters } from "../hooks/useFilters";
import { getPreferredAirport } from "../hooks/getPreferredAirports";
import { useNavigate, useLocation } from "react-router-dom";
import { SELECTED_CABINS, SELECTED_CLASS } from "../utils/enums";
import { getCountryCode } from "../utils/countryCodeLookup";
import { useBaggage } from "../hooks/useBaggage";
import { SEARCH_API_QUERY_PARAMS } from "../utils/constants";
import moment from "moment";
import { DrawerComponent } from "./common/Drawer";
import { nanoid } from "nanoid";
import { Box } from "@mui/material";
import { IsMobileOrBrowser } from "../hooks/isBrowserOrMobile";
import {
  dateFromFormattedToMoment,
  getItemFromLocalStorage,
} from "../common/methods";
import SearchIcon from "@mui/icons-material/Search";
import HomeMobileSearch from "./flight/HomeMobileSearch";
import SwapHorizontalCircleIcon from "@mui/icons-material/SwapHorizontalCircle";
import { isTablet } from "react-device-detect";
import $ from "jquery";
import { useGeolocation } from "../hooks/useGeolocation";
import { Modal } from "./ModalTransitions";
import { searchAirports, debounce } from "../utils/airportSearchNew";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import styled from 'styled-components';
import { NewDatePicker } from './common/NewDatePicker';
import BannerNewMobile from './BannerNewMobile';
import { CookieConsent } from './common/CookieConsent';
import flightIcon from "../assets/svg2/flyWHITE.svg";
import bedIcon from "../assets/svg2/bedWHITE.svg";

// Import SVG icons as inline components
const DepartureSVG = ({ style }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 64 64" 
    style={style}
  >
    <path d="M61 48.2H3c-.6 0-1 .4-1 1s.4 1 1 1h58c.6 0 1-.4 1-1s-.4-1-1-1zM7.3 30.3l11 8.1c.6.4 1.3.7 2 .7.5 0 1-.1 1.4-.3l32.5-15.3c2.5-1.2 3.6-4.2 2.5-6.8-.6-1.3-1.6-2.2-3-2.7-1.3-.5-2.7-.4-3.9.3l-10 5.1L27.3 14c-.3-.1-.5-.1-.8 0l-5.4 2.3c-.3.1-.6.4-.6.8 0 .3.1.7.4.9l8.4 6.8-8.9 4.6-8-2.8c-.3-.1-.5-.1-.8.1l-4.1 2c-.3.2-.5.5-.5.8-.1.3 0 .6.3.8zm4.7-1.7 8 2.8c.3.1.5.1.8-.1l10.7-5.5c.3-.2.5-.5.5-.8s-.1-.7-.4-.9l-8.3-6.7 3.5-1.5 12.5 5.5c.3.1.6.1.9 0l10.4-5.3c.7-.4 1.6-.4 2.4-.2.8.3 1.4.9 1.8 1.6.7 1.6.1 3.4-1.5 4.1L20.8 37c-.4.2-1 .2-1.3-.1l-9.7-7.1z" fill="#003663" />
  </svg>
);

const ArrivalSVG = ({ style }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 64 64" 
    style={style}
  >
    <path d="M61 50.2H3c-.6 0-1 .4-1 1s.4 1 1 1h58c.6 0 1-.4 1-1s-.4-1-1-1zM11.6 26.4c.2 1.2 1 2.2 2.2 2.6l33.8 12.2c.6.2 1.1.3 1.7.3 2.1 0 4.1-1.3 4.8-3.4.5-1.3.4-2.7-.2-4-.6-1.2-1.7-2.2-3-2.6L40.2 28l-4.9-12.6c-.1-.3-.3-.5-.6-.6l-5.5-2.2c-.3-.1-.7-.1-1 .1s-.4.6-.4.9l1.2 11-9.6-3.1-3.7-7.7c-.1-.2-.3-.4-.6-.5l-4.3-1.4c-.3-.1-.7 0-1 .2s-.4.6-.3.9zM14.2 15l3.7 7.7c.1.2.3.4.6.5l11.4 3.7c.3.1.7 0 .9-.2.3-.2.4-.5.4-.9l-1.1-10.6 3.5 1.4 5 12.7c.1.3.3.5.6.6l11.1 3.6c.8.3 1.4.8 1.8 1.6s.4 1.6.1 2.4c-.6 1.6-2.4 2.4-4 1.9L14.4 27.2c-.5-.2-.8-.6-.9-1.1l-1.8-11.9z" fill="#003663" />
  </svg>
);

// Styled components
const INPUT_HEIGHT = '56px';

const CustomDatePickerContainer = styled.div`
  position: relative;
  width: calc(100% + 48px);
  margin-left: -24px;
  
  .calendar-icon {
    position: absolute;
    left: 16px;
    top: 38px;
    transform: translateY(-50%);
    z-index: 2;
    color: #003663;
    pointer-events: none;
  }

  input {
    height: 76px !important;
  }
`;

const SmallerInput = styled.input`
  width: calc(100% - 10px) !important;
  margin-right: 10px;
`;

const DatePickerWrapper = styled.div`
  position: relative;
  width: 100%;

  .calendar-icon {
    position: absolute;
    left: ${props => props.isMobile ? '4px' : '16px'};
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    color: #003663;
    pointer-events: none;
  }

  @media (max-width: 768px) {
    margin: 0 16px;
    width: calc(100% - 32px);
  }

  input {
    padding-left: 60px !important;
    height: 56px !important;
    width: calc(100% + ${props => props.isMobile ? '32px' : '22px'}) !important;
    margin-left: ${props => props.isMobile ? '-16px' : '-8px'};
    font-size: 16px !important;
    font-weight: 500 !important;
  }
  
  .react-datepicker__input-container input {
    width: 100% !important;
    height: 56px !important;
    border-radius: 12px !important;
    padding-left: 60px !important;
    font-size: 18px !important;
    font-weight: 500 !important;
  }
`;

// Add a custom BannerDatePickerWrapper to match input styling with other inputs in BannerNew
const BannerDatePickerWrapper = styled.div`
  position: relative;
  width: 100%;
  
  /* Override NewDatePicker's MainInput styling specifically for BannerNew */
  .banner-datepicker-custom-input {
    border: 1px solid #e7e7e7 !important;
    border-radius: 12px !important;
    height: 56px !important;
    background-color: white !important;
    width: 100% !important;
    font-size: 18px !important;
    display: flex;
    align-items: center;
    
    /* Match the styling to other inputs in BannerNew */
    &:hover {
      border-color: #003663 !important;
    }
    
    /* When the calendar is open in the header */
    &.in-header {
      width: 455px !important; /* Match the width we set in NewDatePicker */
      max-width: 455px !important;
      border-color: #003663 !important;
    }
  }
`;

// Add a new styled component for calendar popup
const CalendarPopup = styled.div`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 1050px;
  margin-top: 8px;
  
  .date-picker {
    width: 100%;
  }
  
  .date-input {
    height: 56px !important;
    border-radius: 12px;
    padding-left: 48px;
  }
`;

// Animations
const slideVariants = {
  hidden: {
    transform: "translateX(100%)",
    opacity: 0,
  },
  visible: {
    transform: "translateX(0%)",
    opacity: 1,
    transition: { duration: 0.5, ease: "easeInOut" },
  },
  exit: {
    transform: "translateX(-100%)",
    opacity: 0,
    transition: { duration: 0.5, ease: "easeInOut" },
  },
};

function clickDateRange() {
  let a = document.getElementsByClassName('date') 
  setTimeout(() => {
    for (let item of a) {
    }
  }, 500);
}

// Add mobile-specific styled components
const MobileDrawerContent = styled.div`
  padding: 16px;
  height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  background-color: #fff;
`;

const MobileSearchButton = styled.button`
  width: 100%;
  padding: 16px;
  background-color: #FBD316;
  color: #003663;
  border: none;
  border-radius: 12px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
  &:hover {
    background-color: #e6be14;
  }
`;

const MobileStepIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 24px;
  
  .step {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${props => props.active ? '#003663' : 'rgba(0, 54, 99, 0.2)'};
  }
`;

// Add CSS override styles to ensure proper input text spacing
const inputOverrideStyle = document.createElement('style');
inputOverrideStyle.textContent = `
  /* Force input text spacing in BannerNew */
  .banner .form-control.flight1,
  .banner .form-control.flight2,
  .banner .form-control.custom-dropdown {
    padding-left: 60px !important;
    font-size: 18px !important;
    font-weight: 500 !important;
    text-align: left !important;
    text-indent: 0 !important;
  }
  
  /* Travelers input specific styling */
  .banner .form-control.bg-user {
    padding-left: 50px !important;
    font-size: 18px !important;
    font-weight: 500 !important;
    text-align: left !important;
    text-indent: 0px !important;
  }
  
  /* Ensure GroupedAirportSearch inputs follow the same pattern */
  .banner .grouped-airport-search input,
  .banner .grouped-airport-search .form-control {
    padding-left: 60px !important;
    font-size: 18px !important;
    font-weight: 500 !important;
    text-align: left !important;
    text-indent: 0 !important;
  }
  
  /* Date picker input text positioning */
  .banner .date-picker-custom-input {
    padding-left: 50px !important;
    font-size: 18px !important;
    font-weight: 500 !important;
  }
  
  /* Increase weight for origin / destination inputs */
  .banner .form-control.flight1,
  .banner .form-control.flight2 {
    font-weight: 600 !important;
  }
`;
if (!document.head.querySelector('style[data-input-override]')) {
  inputOverrideStyle.setAttribute('data-input-override', 'true');
  document.head.appendChild(inputOverrideStyle);
}

// Styled input components with specific padding to fix icon-text spacing
const StyledOriginInput = styled.input`
  @media (min-width: 769px) {
    padding-left: 60px !important;
    padding-right: 16px !important;
    height: 56px !important;
    text-align: left !important;
    
    &.form-control {
      padding-left: 60px !important;
      height: 56px !important;
      text-align: left !important;
    }
  }
  
  /* Mobile styles to prevent interference */
  @media (max-width: 768px) {
    padding-left: 50px !important;
    padding-right: 16px !important;
    height: 56px !important;
    text-align: left !important;
  }
`;

const StyledDestinationInput = styled.input`
  @media (min-width: 769px) {
    padding-left: 60px !important;
    padding-right: 16px !important;
    height: 56px !important;
    text-align: left !important;
    
    &.form-control {
      padding-left: 60px !important;
      height: 56px !important;
      text-align: left !important;
    }
  }
  
  /* Mobile styles to prevent interference */
  @media (max-width: 768px) {
    padding-left: 50px !important;
    padding-right: 16px !important;
    height: 56px !important;
    text-align: left !important;
  }
`;

// Styled traveler input for uniform width (5px wider) - Desktop only
const StyledTravelerInput = styled.input`
  @media (min-width: 769px) {
    width: calc(100% + 5px) !important;
    height: 56px !important;
    margin-left: -2.5px !important; /* Center the extra width */
    
    &.form-control {
      width: calc(100% + 5px) !important;
      height: 56px !important;
    }
  }
  
  /* Ensure mobile styles don't interfere */
  @media (max-width: 768px) {
    width: 100% !important;
    height: 56px !important;
    margin-left: 0 !important;
  }
`;

// Styled date picker container - Desktop only (same height as other inputs)
const StyledDatePickerContainer = styled.div`
  @media (min-width: 769px) {
    height: 56px !important; /* Same as other inputs */
    
    .banner-datepicker-custom-input {
      height: 56px !important;
    }
  }
  
  /* Ensure mobile styles don't interfere */
  @media (max-width: 768px) {
    height: 56px !important;
    
    .banner-datepicker-custom-input {
      height: 56px !important;
    }
  }
`;

const Banner = ({ showSearchBar = true, minHeight = "475px", translation }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // ALL STATE DECLARATIONS FIRST - CRITICAL FOR REACT HOOKS ORDER
  const [isMobile, setIsMobile] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [blurBackground, setblurBackground] = useState(false);
  const [destinationInputFocused, setDestinationInputFocused] = useState(false);
  const [viewOriginLookup, setViewOriginLookup] = useState(false);
  const [viewDestinationLookup, setViewDestinationLookup] = useState(false);
  const [_travellerDropDownShow, _setTravellerDropDownShow] = useState(false);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [changeSearch, setChangeSearch] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [originValue, setOriginValue] = useState('');
  const [originCode, setOriginCode] = useState("");
  const [originCity, setOriginCity] = useState("");
  const [destinationValue, setDestinationValue] = useState('');
  const [destinationCode, setDestinationCode] = useState("");
  const [destinationCity, setDestinationCity] = useState("");
  const [selectedClassState, setSelectedClassState] = useState("M");
  const [originSearchResults, setOriginSearchResults] = useState([]);
  const [destinationSearchResults, setDestinationSearchResults] = useState([]);
  const [isOriginSearching, setIsOriginSearching] = useState(false);
  const [isDestinationSearching, setIsDestinationSearching] = useState(false);
  const [activeInput, setActiveInput] = useState('start');
  const [currentDrawer, setCurrentDrawer] = useState(null);
  const [currentMobileStep, setCurrentMobileStep] = useState(1);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [mobileActiveInput, setMobileActiveInput] = useState(null);

  // prevent geo prefill loop
  const [originPrefilled, setOriginPrefilled] = useState(false);

  // STORE HOOKS AND OTHER NON-STATE HOOKS
  const { geolocation } = useGeolocation();
  const filterRoute = useStoreFly((state) => state.filterRoute);
  const setReturnOrOneWay = useStoreFly((state) => state.setReturnOrOneWay);
  const returnOrOneWay = useStoreFly((state) => state.returnOrOneWay);
  const resetFilterRoute = useStoreFly((state) => state.resetFilterRoute);
  const setFilterClass = useStoreFly((state) => state.setFilterClass);
  const setFilter = useStoreFly((state) => state.setFilter);
  const resetFilters = useStoreFly((state) => state.resetFilters);
  const setPassengers = useStoreFly((state) => state.setPassengers);
  const locations = useStoreFly((state) => state.locations);
  
  // DERIVED VALUES
  const { destination, origin, originInput, destinationInput } = filterRoute;
  const {
    dateFrom,
    dateTo,
    flyFrom,
    flyTo,
    adults,
    babies,
    children,
    selectedAirlines,
    maxStops,
    flightTimeGoing,
    flightTimeReturning,
    selectedClass,
  } = useFilters();
  const { adultCabin, adultChecked } = useBaggage();
  const currentSearch = getItemFromLocalStorage("search");
  
  // COMPLEX STATE WITH DEPENDENCIES
  const [options, setOptions] = useState({
    adult: adults || 1,
    children: children || 0,
    babies: babies || 0,
    class: "Economy"
  });
  
  const [startDate, setStartDate] = useState(dateFrom ? moment(dateFrom, "DD/MM/YYYY").toDate() : null);
  const [endDate, setEndDate] = useState(dateTo ? moment(dateTo, "DD/MM/YYYY").toDate() : null);
  const [dateRange, setDateRange] = useState({
    startDate: startDate || null,
    endDate: endDate || null
  });
  
  // REFS
  const travellerRef = useRef(null);
  const originRef = useRef(null);
  const destinationRef = useRef(null);
  const datePickerRef = useRef(null);
  
  // CUSTOM STATE GETTER/SETTER
  const travellerDropDownShow = _travellerDropDownShow;
  const setTravellerDropDownShow = (value) => {
    _setTravellerDropDownShow(value);
  };

  // EFFECTS AND CALLBACKS - AFTER ALL STATE IS DECLARED
  // Add additional aggressive CSS override for input styling
  useEffect(() => {
    const additionalStyle = document.createElement('style');
    additionalStyle.textContent = `
      /* Ultra-specific selectors to override all input styling */
      section.banner input.form-control.flight1,
      section.banner input.form-control.flight2,
      section.banner input.form-control.custom-dropdown {
        padding-left: 60px !important;
        text-align: left !important;
        text-indent: 0px !important;
        font-size: 16px !important;
        font-weight: 500 !important;
      }
      
      /* Travelers input with background image adjustment */
      section.banner input.form-control.bg-user {
        padding-left: 50px !important;
        text-align: left !important;
        text-indent: 0px !important;
        font-size: 16px !important;
        font-weight: 500 !important;
        background-position: 15px 50% !important;
      }
      
      /* Override any GroupedAirportSearch component styling */
      section.banner .grouped-airport-search input,
      section.banner .grouped-airport-search .form-control,
      section.banner .airport-search-container input,
      section.banner .airport-search-container .form-control {
        padding-left: 60px !important;
        text-align: left !important;
        text-indent: 0px !important;
        font-size: 16px !important;
        font-weight: 500 !important;
      }
      
      /* Override date picker inputs */
      section.banner .date-picker input,
      section.banner .date-picker .form-control {
        padding-left: 60px !important;
        text-align: left !important;
        font-size: 16px !important;
        font-weight: 500 !important;
      }
      
      /* Nuclear option - override EVERYTHING */
      section.banner input[type="text"],
      section.banner input[type="search"],
      section.banner .form-control {
        text-align: left !important;
        font-size: 16px !important;
        font-weight: 500 !important;
      }
      
      /* Ensure origin/destination inputs get proper padding */
      section.banner input.flight1,
      section.banner input.flight2 {
        padding-left: 60px !important;
      }
    `;
    additionalStyle.setAttribute('data-banner-input-override', 'true');
    if (!document.head.querySelector('style[data-banner-input-override]')) {
      document.head.appendChild(additionalStyle);
    }
    
    return () => {
      const existingStyle = document.head.querySelector('style[data-banner-input-override]');
      if (existingStyle) {
        existingStyle.remove();
      }
    };
  }, []);
  
  // Force style application after component mounts
  useEffect(() => {
    const timer = setTimeout(() => {
      // Find all input elements in the banner and force the styling
      const bannerInputs = document.querySelectorAll('section.banner input.form-control');
      bannerInputs.forEach(input => {
        if (input.classList.contains('flight1') || input.classList.contains('flight2') || input.classList.contains('custom-dropdown')) {
          input.style.paddingLeft = '60px';
          input.style.textAlign = 'left';
          input.style.fontSize = '16px';
          input.style.fontWeight = '500';
        } else if (input.classList.contains('bg-user')) {
          input.style.paddingLeft = '50px';
          input.style.textAlign = 'left';
          input.style.fontSize = '16px';
          input.style.fontWeight = '600';
        }
      });
    }, 100);
    
    return () => clearTimeout(timer);
  }, [viewOriginLookup, viewDestinationLookup, travellerDropDownShow]);
  
  // Initialize date range from filter state
  useEffect(() => {
    if (dateFrom && !startDate) {
      const parsedStartDate = moment(dateFrom, "DD/MM/YYYY").toDate();
      setStartDate(parsedStartDate);
      setDateRange(prev => ({ ...prev, startDate: parsedStartDate }));
    }
    if (dateTo && !endDate && returnOrOneWay === "return") {
      const parsedEndDate = moment(dateTo, "DD/MM/YYYY").toDate();
      setEndDate(parsedEndDate);
      setDateRange(prev => ({ ...prev, endDate: parsedEndDate }));
    }
    
    // Set default dates if none are provided
    if (!dateFrom && !startDate && !dateRange?.startDate) {
      const defaultStartDate = moment().add(10, 'days').toDate();
      const defaultEndDate = moment().add(15, 'days').toDate();
      
      setStartDate(defaultStartDate);
      setDateRange({
        startDate: defaultStartDate,
        endDate: returnOrOneWay === "return" ? defaultEndDate : null
      });
      
      if (returnOrOneWay === "return") {
        setEndDate(defaultEndDate);
      }
    }
  }, [dateFrom, dateTo, startDate, endDate, returnOrOneWay]);
  
  // Button styles
  const circleBtn = {
    width: 32,
    height: 32,
    minWidth: '32px',
    minHeight: '32px',
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 18,
    cursor: "pointer",
    border: "none",
    borderRadius: "50%",
    backgroundColor: "#e9ecef",
    color: "#003663",
    transition: "all 0.2s ease",
    transform: "scale(1)",
    padding: '0',
    lineHeight: '1',
    boxSizing: 'border-box'
  };

  const activeCircleBtn = {
    ...circleBtn,
    backgroundColor: "#FBD316",
  };

  const disabledCircleBtn = {
    ...circleBtn,
    opacity: 0.5,
    cursor: "not-allowed",
    backgroundColor: "#e9ecef"
  };
  
  const getDynamicButtonStyle = () => ({
    backgroundColor: "#FBD316",
    color: "#003663",
    fontWeight: "bold",
    padding: "16px 24px",
    border: "none",
    borderRadius: "16px",
    fontSize: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s ease-in-out",
    boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
    gap: "8px",
    cursor: "pointer",
    height: "56px",
    transform: "scale(1)",
  });

  // Event handlers
  const buttonHoverStyle = (e, isEnabled) => {
    if (isEnabled) {
      e.currentTarget.style.transform = 'scale(1.2)';
    }
  };

  const buttonLeaveStyle = (e) => {
    e.currentTarget.style.transform = 'scale(1)';
  };

  const handleOption = (name, operation) => {
    setOptions((prev) => {
      return {
        ...prev,
        [name]: operation === "plus" ? options[name] + 1 : options[name] - 1,
      };
    });
    if (operation === "plus") {
      setPassengers(`${[name]}`, options[name] + 1);
    } else {
      setPassengers(`${[name]}`, options[name] - 1);
    }
  };

  // Add explicit toggle functions with proper state management
  const openOriginLookup = () => {
    // Close all other dropdowns first
    setViewDestinationLookup(false);
    setTravellerDropDownShow(false);
    setIsCalendarOpen(false);
    
    // Then open this one
    setViewOriginLookup(true);
    setblurBackground(true);
  };
  
  const openDestinationLookup = () => {
    // Close all other dropdowns first
    setViewOriginLookup(false);
    setTravellerDropDownShow(false);
    setIsCalendarOpen(false);
    
    // Then open this one
    setViewDestinationLookup(true);
    setDestinationInputFocused(true);
    setblurBackground(true);
  };
  
  const openTravelerDropdown = () => {
    // Close all other dropdowns first
    setViewOriginLookup(false);
    setViewDestinationLookup(false);
    setIsCalendarOpen(false);
    
    // Then open this one
    setTravellerDropDownShow(true);
    setblurBackground(true);
  };
  
  const closeTravelerDropdown = () => {
    setTravellerDropDownShow(false);
    setblurBackground(false);
    
    // Also ensure we're on the first step in mobile view
    if (isMobile) {
      setCurrentStep(1);
    }
  };
  
  const openCalendar = () => {
    // Close all other dropdowns first
    setViewOriginLookup(false);
    setViewDestinationLookup(false);
    setTravellerDropDownShow(false);
    
    // Then open this one
    setIsCalendarOpen(true);
    setblurBackground(true);
  };

  const handleClass = (name) => {
    setOptions((prev) => {
      return {
        ...prev,
        class: name,
      };
    });
  };
  
  // Clean implementation of date change handler
  const handleDateChange = (newDateRange) => {
    
    // Update state only if we have valid dates
    if (newDateRange?.startDate) {
      setStartDate(newDateRange.startDate);
      setFilter("dateFrom", moment(newDateRange.startDate).format("DD/MM/YYYY"));
    }
    
    if (newDateRange?.endDate) {
      setEndDate(newDateRange.endDate);
      setFilter("dateTo", moment(newDateRange.endDate).format("DD/MM/YYYY"));
    } else if (returnOrOneWay === "oneway") {
      // For one-way flights, clear end date
      setEndDate(null);
      setFilter("dateTo", null);
    }
    
    // Always update the full date range
    setDateRange(newDateRange);
    
    // ✅ DESKTOP ONLY: Close the calendar if all required dates are selected
    if (!isMobile) {
      if ((returnOrOneWay === "return" && newDateRange.startDate && newDateRange.endDate) || 
          (returnOrOneWay === "oneway" && newDateRange.startDate)) {
        // Add a small delay to update UI
        setTimeout(() => {
          setIsCalendarOpen(false);
          setblurBackground(false);
          
          // Auto-open travelers dropdown after date selection
          setTimeout(() => {
            openTravelerDropdown();
          }, 100);
        }, 100);
      }
    }
    // ✅ MOBILE: No auto-advancement - wait for DONE button click
  };

  // ✅ NEW: Handle mobile DONE button click for step advancement
  const handleMobileDateDone = (dateRange) => {
    if (isMobile) {
      if ((returnOrOneWay === "return" && dateRange?.startDate && dateRange?.endDate) || 
          (returnOrOneWay === "oneway" && dateRange?.startDate)) {
        setCurrentStep(4);
        // Auto-open travelers dropdown after DONE click
        setTimeout(() => {
          openTravelerDropdown();
        }, 100);
      }
    }
  };
  
  // Handle step changes
  const handleStepChange = (step) => {
    setCurrentStep(step);
  };

  // Open step function for mobile
  const openStep = (step) => {
    if (isMobile) {
      setCurrentStep(step);
      setblurBackground(true);
      
      // Also reset other dropdowns when changing steps
      if (step === 1) {
        setViewOriginLookup(false);
        setViewDestinationLookup(false);
        setTravellerDropDownShow(false);
        setIsCalendarOpen(false);
      } else if (step === 2) {
        setViewOriginLookup(false);
        setViewDestinationLookup(true);
        setTravellerDropDownShow(false);
        setIsCalendarOpen(false);
      } else if (step === 3) {
        setViewOriginLookup(false);
        setViewDestinationLookup(false);
        setTravellerDropDownShow(false);
        setIsCalendarOpen(true);
      }
    }
  };
  
  // Mobile date picker click
  const handleMobileDatePickerClick = () => {
    if (isMobile) {
      setCurrentStep(3);
      setblurBackground(true);
      
      // Make sure we're opening the date drawer in mobile
      if (typeof openStep === 'function') {
        openStep(3);
      }
    }
  };
  
  // Enhanced search functions with new options
  const searchOriginAirports = async (term) => {
    if (term.length < 2) {
      setOriginSearchResults([]);
      return;
    }
    setIsOriginSearching(true);
    if (!originPrefilled) setOriginPrefilled(true);
    try {
      const results = await searchAirports(term, { 
        limit: 15,
        groupResults: true,
        minifyResults: true 
      });
      setOriginSearchResults(results);
    } catch (error) {
      console.error("Error searching airports for origin:", error);
      setOriginSearchResults([]);
    } finally {
      setIsOriginSearching(false);
    }
  };

  const searchDestinationAirports = async (term) => {
    if (term.length < 2) {
      setDestinationSearchResults([]);
      return;
    }
    setIsDestinationSearching(true);
    try {
      const results = await searchAirports(term, { 
        limit: 15,
        groupResults: true,
        minifyResults: true 
      });
      setDestinationSearchResults(results);
    } catch (error) {
      console.error("Error searching airports for destination:", error);
      setDestinationSearchResults([]);
    } finally {
      setIsDestinationSearching(false);
    }
  };
  
  // Handle input changes
  const handleOriginInputChange = async (eventOrValue) => {
    // Handle both event objects and direct values
    const value = typeof eventOrValue === 'string' ? eventOrValue : eventOrValue?.target?.value || '';
    
    setIsOriginSearching(true);
    setOriginValue(value);
    setFilter("filterRoute", "originInput", value);
    
    if (value.trim() !== '') {
      try {
        const results = await searchAirports(value, { 
          limit: 15,
          groupResults: true,
          minifyResults: true 
        });
        setOriginSearchResults(results || []);
      } catch (error) {
        console.error("Error searching airports for origin:", error);
        setOriginSearchResults([]);
      }
    } else {
      setOriginSearchResults([]);
    }
    setIsOriginSearching(false);
  };

  const handleDestinationInputChange = async (eventOrValue) => {
    // Handle both event objects and direct values
    const value = typeof eventOrValue === 'string' ? eventOrValue : eventOrValue?.target?.value || '';
    
    setIsDestinationSearching(true);
    setDestinationValue(value);
    setFilter("filterRoute", "destinationInput", value);
    
    if (value.trim() !== '') {
      try {
        const results = await searchAirports(value, { 
          limit: 15,
          groupResults: true,
          minifyResults: true 
        });
        setDestinationSearchResults(results || []);
      } catch (error) {
        console.error("Error searching airports for destination:", error);
        setDestinationSearchResults([]);
      }
    } else {
      setDestinationSearchResults([]);
    }
    setIsDestinationSearching(false);
  };
  
  // Handle search click
  const handleSearchClick = async () => {
    // Close all dropdowns before proceeding
    forceCloseAll();
    
    // Format dates properly
    const formattedDateFrom = dateRange?.startDate ? moment(dateRange.startDate).format("DD/MM/YYYY") : null;
    const formattedDateTo = dateRange?.endDate ? moment(dateRange.endDate).format("DD/MM/YYYY") : null;
    
    const currentSearch = getItemFromLocalStorage("search");
    const cityNameFrom = originCity || currentSearch?.cityNameFrom;
    const cityNameTo = destinationCity || currentSearch?.cityNameTo;
    const flyFromCode = originCode || currentSearch?.flyFrom;
    const flyToCode = destinationCode || currentSearch?.flyTo;

    // Validate required fields
    if (!flyFromCode || !flyToCode || !formattedDateFrom) {
      console.error("Missing required search fields:", { flyFromCode, flyToCode, formattedDateFrom });
      return;
    }

    const newSearch = {
      ...currentSearch,
      flyFrom: flyFromCode,
      flyTo: flyToCode,
      cityNameFrom,
      cityNameTo,
      originCode: flyFromCode,
      destinationCode: flyToCode,
      returnOrOneWay,
      dateFrom: formattedDateFrom,
      dateTo: returnOrOneWay === "return" ? formattedDateTo : null,
      adults: options.adult,
      babies: options.babies,
      children: options.children,
      infants: options.babies, // API expects infants field
      selectedClass: selectedClassState || SELECTED_CLASS[options.class] || "M",
      vehicleType: "aircraft",
      limit: 30,
      selectedAirlines: selectedAirlines || [],
      aTimeFrom: "0:00",
      aTimeTo: "24:00",
      dtimeFrom: "0:00",
      dtimeTo: "24:00",
      retAtimeFrom: null,
      retAtimeTo: null,
      retDtimeFrom: null,
      retDtimeTo: null,
      returnFromDate: returnOrOneWay === "return" ? formattedDateTo : null,
      returnToDate: returnOrOneWay === "return" ? formattedDateTo : null,
      curr: "EUR",
    };
    localStorage.setItem("search", JSON.stringify(newSearch));
    navigate(`/search?session=${nanoid()}`);
  };
  
  // Force close all dropdown modals
  const forceCloseAll = useCallback(() => {
    // Close all dropdowns
    setViewOriginLookup(false);
    setViewDestinationLookup(false);
    setDestinationInputFocused(false);
    setTravellerDropDownShow(false);
    setIsCalendarOpen(false);
    setblurBackground(false);
    setChangeSearch(false);
    
    // Reset modal states
    setCurrentStep(1);
    
    // Remove any focus if needed
    document.activeElement && document.activeElement.blur && document.activeElement.blur();
    
    // If on mobile, make sure scroll is enabled
    if (typeof document !== 'undefined') {
      document.body.style.overflow = '';
    }
    
    // NOTE: We don't clear input values here to preserve user selections
  }, []);

  // Run forceCloseAll on initial render
  useEffect(() => {
    forceCloseAll();
    
    // Also run after a small delay to catch any late state changes
    const timeoutId = setTimeout(forceCloseAll, 100);
    
    return () => clearTimeout(timeoutId);
  }, [forceCloseAll]);

  // Use the forceCloseAll in our route change effect
  useEffect(() => {
    // Close all dropdowns when route changes
    forceCloseAll();
    
    if (location.pathname === "/") {
      localStorage.setItem("search", "{}");
      localStorage.setItem("filter", "{}");
    }
  }, [location.pathname, forceCloseAll]);

  // Add click outside handler using capturing phase to ensure it runs first
  useEffect(() => {
    const handleClickOutside = (e) => {
      // Don't close if clicking on dropdown items or buttons
      if (e.target.closest('.traveller-dropdown') || 
          e.target.closest('.calendar-popup') ||
          e.target.closest('[data-airport-item]') ||
          e.target.closest('button') ||
          e.target.closest('.dropdown-container') || 
          e.target.closest('.MuiDialog-root') ||
          e.target.closest('.drawer-component')) {
        return;
      }
      
      // Check if the click is outside any of our dropdown containers
      const isOutsideAllDropdowns = 
        (!originRef.current || !originRef.current.contains(e.target)) &&
        (!destinationRef.current || !destinationRef.current.contains(e.target)) &&
        (!travellerRef.current || !travellerRef.current.contains(e.target)) &&
        (!datePickerRef.current || !datePickerRef.current.contains(e.target));
      
      if (isOutsideAllDropdowns) {
        forceCloseAll();
      }
    };
    
    // Use capture phase to ensure this runs before other handlers
    document.addEventListener('mousedown', handleClickOutside, true);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside, true);
    };
  }, [forceCloseAll]);

  useEffect(() => {
     
    if (location.pathname === "/") {
      localStorage.setItem("search", "{}");
      localStorage.setItem("filter", "{}");
    } 

  }, [location.pathname]);
  
  // Effect: Reset filters on route change
  useEffect(() => {
    if (location.pathname === "/") {
      resetFilterRoute();
      resetFilters();
    }
  }, [location.pathname, resetFilterRoute, resetFilters, setFilter]);
  
  // Effect: Set default airport based on geolocation
  useEffect(() => {
    if (geolocation && !originCode && !originPrefilled) {
      const userCountryRaw = geolocation.city;
      const countryCode = getCountryCode(userCountryRaw) || userCountryRaw;
      const preferredAirport = getPreferredAirport(countryCode, {
        latitude: geolocation.latitude,
        longitude: geolocation.longitude,
      });
      if (preferredAirport) {
        const formattedValue = `${preferredAirport.city_name} - ${preferredAirport.name}`;
        setOriginCity(formattedValue);
        setOriginValue(formattedValue);
        setOriginCode(preferredAirport.id);
        setFilter("filterRoute", "origin", preferredAirport);
        setOriginPrefilled(true);
      }
    }
  }, [geolocation, originCode, setFilter]);
  
  // Effect: Clear end date when switching to one-way
  useEffect(() => {
    if (returnOrOneWay === "oneway" && dateRange?.endDate) {
      setDateRange({
        startDate: dateRange.startDate,
        endDate: null
      });
      setEndDate(null);
      setFilter("dateTo", null);
    }
  }, [returnOrOneWay, dateRange?.startDate]);

  // Effect: Handle flight type changes
  useEffect(() => {
    // If switching to one-way, clear the end date
    if (returnOrOneWay === "oneway") {
      if (dateRange?.endDate) {
        setDateRange({
          startDate: dateRange.startDate,
          endDate: null
        });
        setEndDate(null);
        setFilter("dateTo", null);
      }
    }
    // If switching back to return from one-way, ensure proper state
    else if (returnOrOneWay === "return") {
      // Force a re-render by creating a new dateRange object
      if (dateRange?.startDate && !dateRange?.endDate) {
        setDateRange({
          startDate: dateRange.startDate,
          endDate: null
        });
      }
    }
  }, [returnOrOneWay]);

  // Effect: Set return as default
  useEffect(() => {
    setReturnOrOneWay("return");
  }, []); // Run only once on component mount
  
  // Format dates
  const dateFromFormatted = currentSearch?.dateFrom ? 
    moment(currentSearch.dateFrom, "DD/MM/YYYY").format("MMM D") : "";

  const dateToFormatted = currentSearch?.returnToDate ? 
    moment(currentSearch.returnToDate, "DD/MM/YYYY").format("MMM D") : "";
  
  // Add effect to open the traveller dropdown after calendar closes
  useEffect(() => {
    // When dates are selected, if we were on the calendar step, go back to step 1
    if ((returnOrOneWay === "return" && dateRange?.startDate && dateRange?.endDate) || 
        (returnOrOneWay === "oneway" && dateRange?.startDate)) {
      if (!isCalendarOpen && currentStep === 3) {
        setCurrentStep(1);
      }
    }
  }, [isCalendarOpen, dateRange, returnOrOneWay, currentStep]);
  
  // Add an effect to ensure travelerDropDownShow is reset when component unmounts or the page changes
  useEffect(() => {
    // Reset state when component mounts
    setTravellerDropDownShow(false);
    
    // Reset on unmount
    return () => {
      setTravellerDropDownShow(false);
    };
  }, []);
  
  // Add useEffect to close all dropdowns when route changes
  useEffect(() => {
    // Close all dropdowns when route changes
    forceCloseAll();
  }, [location.pathname]);
  
  // Add keydown event listener for escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        forceCloseAll();
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [forceCloseAll]);
  
  // Mobile-specific state already declared above

  // Add mobile-specific handlers
  const handleMobileStepChange = (step) => {
    setCurrentMobileStep(step);
    setMobileDrawerOpen(true);
  };

  const handleMobileDrawerClose = () => {
    setMobileDrawerOpen(false);
    setCurrentMobileStep(1);
    setMobileActiveInput(null);
  };

  const handleMobileInputClick = (inputType) => {
    if (!isMobile) return;
    
    switch(inputType) {
      case 'origin':
        setCurrentMobileStep(1);
        setMobileActiveInput('origin');
        setViewOriginLookup(true);
        break;
      case 'destination':
        setCurrentMobileStep(2);
        setMobileActiveInput('destination');
        setViewDestinationLookup(true);
        break;
      case 'dates':
        setCurrentMobileStep(3);
        setMobileActiveInput('dates');
        setIsCalendarOpen(true);
        break;
      case 'travelers':
        setCurrentMobileStep(4);
        setMobileActiveInput('travelers');
        setTravellerDropDownShow(true);
        break;
      default:
        break;
    }
    setMobileDrawerOpen(true);
  };
  
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // 🔹 Auto-prefill fields with previous search (desktop)
  useEffect(() => {
    try {
      const stored = JSON.parse(localStorage.getItem("search") || "{}");
      if (!stored || Object.keys(stored).length === 0) return;

      // Origin
      if (!originCode && stored.flyFrom) {
        const originDisplay = stored.cityNameFrom || stored.flyFrom;
        setOriginCode(stored.flyFrom);
        setOriginCity(originDisplay);
        setOriginValue(originDisplay);
        setFilter("filterRoute", "origin", {
          id: stored.flyFrom,
          city_name: originDisplay,
          name: originDisplay
        });
      }

      // Destination
      if (!destinationCode && stored.flyTo) {
        const destDisplay = stored.cityNameTo || stored.flyTo;
        setDestinationCode(stored.flyTo);
        setDestinationCity(destDisplay);
        setDestinationValue(destDisplay);
        setFilter("filterRoute", "destination", {
          id: stored.flyTo,
          city_name: destDisplay,
          name: destDisplay
        });
      }

      // Dates
      if (stored.dateFrom) {
        const start = moment(stored.dateFrom, "DD/MM/YYYY").toDate();
        const end = stored.dateTo ? moment(stored.dateTo, "DD/MM/YYYY").toDate() : null;
        setDateRange({ startDate: start, endDate: end });
        setStartDate(start);
        setEndDate(end);
      }

      // Pax & class
      if (stored.adults || stored.children || stored.babies) {
        setOptions((prev) => ({
          ...prev,
          adult: stored.adults || prev.adult,
          children: stored.children || prev.children,
          babies: stored.babies || prev.babies
        }));
      }
      if (stored.selectedClass) {
        setSelectedClassState(stored.selectedClass);
      }

      // Trip type
      if (stored.returnOrOneWay) {
        setReturnOrOneWay(stored.returnOrOneWay);
      }
    } catch (err) {
      console.warn("Could not prefill banner from stored search", err);
    }
  }, []);

  if (isMobile) {
    return <BannerNewMobile translation={translation} showSearchBar={showSearchBar} />;
  }
  
  return (
    <section
      className="banner"
      style={{ minHeight: isMobile ? "100px" : minHeight, height: 300 }}
    >

      
      {showSearchBar && (
        <div className="container" style={{ paddingLeft: "15px", height: 300 }}>
          <div className="row">
            <div className="col-lg-12 bot-minus col-md-12 col-12">
              {/* Navigation Tabs */}
              <ul className="nav nav-tabs">
                <li>
                  <a href="/" className="active">
                  <img src={flightIcon} alt="Flight"  style={{ width: '50px', height: '50px' }} /> Flights
                  </a>
                </li>
                <li>
                  <a href="hotels">
                  <img src={bedIcon} alt="Hotel" style={{ width: '50px', height: '50px' }} /> Hotels                  </a>
                </li>
              </ul>
              
              {/* Tab Content */}
              <div className="tab-content">
                <div
                  id="tab-1"
                  className="tab-pane fade in show active"
                  style={{
                    paddingTop: "15px",
                  }}
                >
                  {/* Mobile Flight Type Selection */}
                  <div className="col-lg-12 col-md-12 col-12">
                    {isMobile && location.pathname === "/" && (
                      <div className="col-lg-12 radiobg p-0 col-md-12 col-12">
                        <div className="custom-control custom-radio">
                          <input
                            type="radio"
                            id="return"
                            name="customRadio"
                            className="custom-control-input return-radio"
                            value="return"
                            checked={returnOrOneWay === "return"}
                            onChange={() => {
                              setReturnOrOneWay("return");
                            }}
                            customHeight="56px"
                          />
                          <label className="custom-control-label" htmlFor="return">
                            {translation("return")}
                          </label>
                        </div>
                        <div className="custom-control custom-radio">
                          <input
                            type="radio"
                            id="oneway"
                            name="customRadio"
                            className="custom-control-input oneway-radio"
                            value="oneway"
                            checked={returnOrOneWay === "oneway"}
                            onChange={() => {
                              setReturnOrOneWay("oneway");
                            }}
                          />
                          <label className="custom-control-label" htmlFor="oneway">
                            {translation("one_way")}
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                  
                  {/* Mobile Search Info Display (when not on homepage) */}
                  {isMobile && location.pathname !== "/" && (
                    <div
                      className="d-flex justify-content-between align-items-center"
                      style={{
                        color: "#fff",
                      }}
                    >
                      <div
                        style={{
                          color: "white",
                          display: "flex",
                        }}
                        onClick={() => {
                          setChangeSearch(true);
                        }}
                      >
                        <SearchIcon />
                        {translation("change")}
                      </div>
                      <div className="flex-column">
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ gap: "10px"}}
                        >
                          <span>{currentSearch?.originCode?.substring(0, 3) || currentSearch?.cityNameFrom?.substring(0, 3)}</span> -
                          <span>{currentSearch?.destinationCode?.substring(0, 3) || currentSearch?.cityNameTo?.substring(0, 3)}</span>
                        </div>
                        <div>
                          <span
                            style={
                              currentSearch?.returnOrOneWay !== "oneway"
                                ? { textAlign: "center" }
                                : {}
                            }
                          >
                            {
                              translation(dateFromFormatted?.split(" ")[0]?.toLowerCase())
                            }
                            {" "}
                            {
                              dateFromFormatted?.split(" ")[1]
                            }
                            {" "}
                          </span>

                          {currentSearch?.returnOrOneWay !== "oneway" && (
                            <>
                              {" "}-{" "}
                              <span>
                                {
                                  translation(dateToFormatted?.split(" ")[0]?.toLowerCase())
                                }
                                {" "}
                                {
                                  dateToFormatted?.split(" ")[1]
                                }
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="row">
                    {/* Desktop Flight Type Radio Buttons */}
                    {!isMobile && (
                      <>
                        <div className="col-lg-12 col-md-12 col-12">
                          <FormControl>
                            <RadioGroup defaultValue="return" row>
                              <FormControlLabel
                                className="custom-control-label-react"
                                value="return"
                                checked={returnOrOneWay === "return"}
                                control={
                                  <Radio
                                    className="return-radio"
                                    sx={{
                                      color: "white",
                                      "&.Mui-checked": {
                                        color: "white",
                                      },
                                    }}
                                  />
                                }
                                label={translation("return")}
                                sx={{
                                  ".MuiTypography-root": {
                                    fontWeight: 500,
                                    fontSize: 16,
                                    fontFamily: "'Poppins', sans-serif",
                                  },
                                }}
                                onChange={() => {
                                  setReturnOrOneWay("return");
                                }}
                              />
                              <FormControlLabel
                                className="custom-control-label-react"
                                value="oneway"
                                checked={returnOrOneWay === "oneway"}
                                control={
                                  <Radio
                                    className="oneway-radio"
                                    sx={{
                                      color: "white",
                                      "&.Mui-checked": {
                                        color: "white",
                                      },
                                    }}
                                    onChange={() => {
                                      setReturnOrOneWay("oneway");
                                    }}
                                  />
                                }
                                label={translation("one_way")}
                                sx={{
                                  ".MuiTypography-root": {
                                    fontWeight: 500,
                                    fontSize: 16,
                                    fontFamily: "'Poppins', sans-serif",
                                  },
                                }}
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </>
                    )}
                  </div>
                  
                  <div className="row sprdiv align-items-end">
                    <div className="col-lg-9 col-md-9 col-12">
                      {/* Desktop Search Form */}
                      {!isMobile && (
                        <div style={{ 
                          display: 'flex', 
                          alignItems: 'flex-start', 
                          width: '100%',
                          position: 'relative'
                        }}>
                          {/* Main inputs container - maximum width */}
                          <div style={{ 
                            width: '100%',
                            marginRight: '0px'
                          }}>
                            {/* First row: Origin and Destination */}
                            <div style={{ 
                              display: 'flex', 
                              marginBottom: '12px', 
                              gap: '10px',
                              width: '100%'
                            }}>
                              {/* Origin input */}
                              <div style={{ width: '50%' }}> {/* Changed from 45% to 50% */}
                                <div className="form-group" style={{ position: 'relative' }}>
                                  <div style={{
                                    position: 'absolute',
                                    left: '18px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    zIndex: 2,
                                    pointerEvents: 'none'
                                  }}>
                                    <DepartureSVG style={{ 
                                      width: '22px', 
                                      height: '22px'
                                    }} />
                                  </div>
                                  <GroupedAirportSearch
                                    inputValue={originValue}
                                    onSelect={(airport) => {
                                                    const formattedValue = `${airport.city_name} - ${airport.name}`;
                                                    setOriginCity(formattedValue);
                                                    setOriginValue(formattedValue);
                                                    setOriginCode(airport.id);
                                                    setFilter("filterRoute", "origin", airport);
                                                    setViewOriginLookup(false);
                                                    setblurBackground(false);
                                                    
                                                    // Auto-focus on destination input and open dropdown
                                                    setTimeout(() => {
                                                      if (destinationRef.current) {
                                                        destinationRef.current.focus();
                                                      }
                                                      openDestinationLookup();
                                                    }, 100);
                                                  }}
                                    onInputChange={handleOriginInputChange}
                                    placeholder={translation("origin")}
                                    className="form-control flight1 custom-dropdown"
                                    limit={15}
                                    groupResults={true}
                                    onDropdownToggle={(isOpen) => {
                                      setViewOriginLookup(isOpen);
                                      setblurBackground(isOpen);
                                    }}
                                    style={{ 
                                      paddingLeft: '60px',
                                      fontSize: '16px',
                                      fontWeight: '500'
                                    }}
                                  />
                                </div>
                              </div>

                              {/* Destination input */}
                              <div style={{ width: '50%' }}> {/* Changed from 55% to 50% */}
                                <div className="form-group" style={{ position: 'relative' }}>
                                  <div style={{
                                    position: 'absolute',
                                    left: '18px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    zIndex: 2,
                                    pointerEvents: 'none'
                                  }}>
                                    <ArrivalSVG style={{ 
                                      width: '22px', 
                                      height: '22px'
                                    }} />
                                  </div>
                                  <GroupedAirportSearch
                                    inputValue={destinationValue}
                                    onSelect={(airport) => {
                                                    const formattedValue = `${airport.city_name} - ${airport.name}`;
                                                    setDestinationCity(formattedValue);
                                                    setDestinationValue(formattedValue);
                                                    setDestinationCode(airport.id);
                                                    setFilter("filterRoute", "destination", airport);
                                                    setViewDestinationLookup(false);
                                                    setblurBackground(false);
                                                    
                                                    // Auto-open date picker after destination selection
                                                    setTimeout(() => {
                                                      openCalendar();
                                                    }, 100);
                                                  }}
                                    onInputChange={handleDestinationInputChange}
                                    placeholder={translation("destination")}
                                    className="form-control flight2 custom-dropdown"
                                    limit={15}
                                    groupResults={true}
                                    onDropdownToggle={(isOpen) => {
                                      setViewDestinationLookup(isOpen);
                                      setblurBackground(isOpen);
                                      setDestinationInputFocused(isOpen);
                                    }}
                                    style={{ 
                                      paddingLeft: '60px',
                                      fontSize: '16px',
                                      fontWeight: '500'
                                    }}
                                  />
                                                  </div>
                              </div>
                            </div>


                            {/* Second row: Date picker and Travelers */}
                            <div style={{ 
                              display: 'flex', 
                              gap: '10px',
                              width: '100%'
                            }}>
                              {/* Date picker */}
                              <div style={{ width: '50%' }}>
                                <div className="form-group m-0">
                                  <StyledDatePickerContainer 
                                    onClick={() => openCalendar()}
                                    style={{
                                      position: 'relative',
                                      border: '1px solid #e7e7e7',
                                      borderRadius: '8px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      backgroundColor: 'white',
                                      height: isMobile ? '56px' : '61px',
                                      cursor: 'pointer',
                                      width: '100%'
                                    }}
                                  >
                                    <CalendarTodayIcon style={{ 
                                      color: '#003663', 
                                      margin: '0 18px',
                                      fontSize: '22px'
                                    }} />
                                    
                                    <div style={{ 
                                      display: 'flex', 
                                      flex: 1, 
                                      position: 'relative',
                                      width: '100%'
                                    }}>
                                      <div style={{ 
                                        flex: 1, 
                                        padding: '0 8px',
                                        fontSize: '14px'
                                      }}>
                                                                                  {dateRange.startDate ? (
                                            <div style={{ 
                                              fontWeight: '500',
                                              color: '#003663',
                                              fontSize: '16px'
                                            }}>
                                              {moment(dateRange.startDate).format('DD/MM/YYYY')}
                                            </div>
                                        ) : (
                                          <div style={{ 
                                            fontWeight: 500,
                                            color: '#9CA3AF',
                                            fontSize: '16px' 
                                          }}>
                                            {translation("departure_date")}
                                          </div>
                                        )}
                                      </div>
                                      
                                      {returnOrOneWay === 'return' && (
                                        <div style={{ 
                                          flex: 1, 
                                          padding: '0 8px',
                                          fontSize: '14px',
                                          borderLeft: '1px solid #e7e7e7' 
                                        }}>
                                          {dateRange.endDate ? (
                                            <div style={{ 
                                              fontWeight: '500',
                                              color: '#003663',
                                              fontSize: '16px' 
                                            }}>
                                              {moment(dateRange.endDate).format('DD/MM/YYYY')}
                                            </div>
                                          ) : (
                                            <div style={{ 
                                              fontWeight: 500,
                                              color: '#9CA3AF', 
                                              fontSize: '16px'
                                            }}>
                                              {translation("return_date")}
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </StyledDatePickerContainer>
                                  
                                  {isCalendarOpen && (
                                    <>
                                      <div 
                                        className="calendar-backdrop"
                                        onClick={() => {
                                          setIsCalendarOpen(false);
                                          setblurBackground(false);
                                        }}
                                        style={{
                                          position: 'fixed',
                                          top: 0,
                                          left: 0,
                                          right: 0,
                                          bottom: 0,
                                          backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                          zIndex: 998
                                        }}
                                      />
                                      <div 
                                        className="calendar-popup"
                                        style={{
                                          position: 'absolute',
                                          top: '50%',
                                          left: '-24%', // Changed from -19% to -30% to move it more to the left
                                          transform: 'translateX(0)',
                                          zIndex: 999,
                                          backgroundColor: 'white',
                                          borderRadius: '8px',
                                          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                                          width: '700px',
                                          marginTop: '8px'
                                        }}
                                      >
                                        <NewDatePicker
                                          key={`datepicker-${returnOrOneWay}`}
                                          isRange={returnOrOneWay === "return"}
                                          value={dateRange}
                                          onChange={handleDateChange}
                                          minDate={new Date()}
                                          placeholder={returnOrOneWay === "oneway" ? translation("departure") : translation("select_your_flight_dates")}
                                          returnPlaceholder={translation("return_date")}
                                          departurePlaceholder={translation("departure_date")}
                                          onFocus={() => openCalendar()}
                                          onBlur={() => setblurBackground(false)}
                                          isOpen={isCalendarOpen}
                                          onOpenChange={(open) => {
                                            setIsCalendarOpen(open);
                                            if (!open) {
                                              setblurBackground(false);
                                            }
                                          }}
                                          customHeight="56px"
                                          preventDirectOpen={false}
                                          isMobile={false}
                                          variant="banner"
                                          style={{
                                            height: '56px',
                                            borderRadius: '12px',
                                            fontSize: '16px'
                                          }}
                                        />
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>

                              {/* Travelers input */}
                              <div style={{ width: '50%' }}>
                                <div className="form-group" style={{ margin: 0, position: 'relative' }}>
                                  <StyledTravelerInput
                                    type="text"
                                    className="form-control bg-user"
                                    onClick={() => openTravelerDropdown()}
                                    value={`${Number(options.adult) + Number(options.children) + Number(options.babies)} ${translation("traveler")}${(Number(options.adult) + Number(options.children) + Number(options.babies)) > 1 ? translation("s") : ""} | ${translation(options.class)}`}
                                    placeholder={`1 ${translation("traveler")} | ${translation("Economy")}`}
                                    ref={travellerRef}
                                    style={{
                                      caretColor: isMobile && "transparent",
                                    }}
                                  />
                                  {travellerDropDownShow && (
                                    <div 
                                      className="traveller-dropdown-overlay" 
                                      style={{
                                        position: 'fixed',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        zIndex: 999
                                      }}
                                      onClick={() => {
                                        setTravellerDropDownShow(false);
                                        setblurBackground(false);
                                      }}
                                    />
                                  )}
                                  <div 
                                    className="traveller-dropdown"
                                    style={{
                                      display: travellerDropDownShow ? 'block' : 'none',
                                      position: 'absolute',
                                      top: '100%',
                                      left: 0,
                                      backgroundColor: '#fff',
                                      borderRadius: '12px',
                                      boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                                      zIndex: 1500,
                                      marginTop: '8px',
                                      width: '320px',
                                      maxHeight: 'none',
                                      overflow: 'visible',
                                      flexDirection: 'column'
                                    }}
                                  >
                                    {/* Header section removed to make dropdown more compact */}
                                    
                                    {/* Travelers section */}
                                    <div style={{ width: '100%', padding: '20px 24px' }}>
                                      {/* Adults */}
                                      <div style={{ 
                                        display: "flex", 
                                        alignItems: "center", 
                                        justifyContent: "space-between",
                                        marginBottom: "10px",
                                        padding: "8px 0",
                                        backgroundColor: "#FFFFFF",
                                        borderBottom: "1px solid #f0f0f0"
                                      }}>
                                        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                          <div style={{ 
                                            color: "#003663",
                                            backgroundColor: "rgba(0, 54, 99, 0.08)",
                                            width: "32px",
                                            height: "32px",
                                            borderRadius: "50%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                          }}>
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                              <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="currentColor"/>
                                            </svg>
                                          </div>
                                          <div>
                                            <div style={{ 
                                              color: "#003663", 
                                              fontSize: "16px", 
                                              fontWeight: "500",
                                              lineHeight: "1.2"
                                            }}>{translation("adults")}</div>
                                            <div style={{ 
                                              color: "#6B7280", 
                                              fontSize: "14px",
                                              lineHeight: "1.2"
                                            }}>{translation("12_years_and_older")}</div>
                                          </div>
                                        </div>
                                        <div style={{ 
                                          display: "flex", 
                                          alignItems: "center", 
                                          gap: "12px" 
                                        }}>
                                          <button
                                            disabled={options.adult <= 1}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              e.preventDefault();
                                              handleOption("adult", "minus");
                                            }}
                                            style={{
                                              width: "32px",
                                              height: "32px",
                                              border: "none",
                                              borderRadius: "50%",
                                              backgroundColor: options.adult <= 1 ? "#E5E7EB" : "#FBD316",
                                              color: options.adult <= 1 ? "#9CA3AF" : "#003663",
                                              fontSize: "18px",
                                              cursor: options.adult <= 1 ? "not-allowed" : "pointer",
                                              boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              transition: "all 0.2s ease"
                                            }}
                                            onMouseEnter={(e) => {
                                              if (options.adult > 1) {
                                                e.currentTarget.style.backgroundColor = "#e6be14";
                                                e.currentTarget.style.transform = "scale(1.1)";
                                              }
                                            }}
                                            onMouseLeave={(e) => {
                                              if (options.adult > 1) {
                                                e.currentTarget.style.backgroundColor = "#FBD316";
                                                e.currentTarget.style.transform = "scale(1)";
                                              }
                                            }}
                                          >
                                            -
                                          </button>
                                          <span style={{ 
                                            fontSize: "18px", 
                                            fontWeight: "600",
                                            minWidth: "20px",
                                            textAlign: "center",
                                            color: "#003663"
                                          }}>{options.adult}</span>
                                          <button
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              e.preventDefault();
                                              handleOption("adult", "plus");
                                            }}
                                            disabled={options.adult >= 6}
                                            style={{
                                              width: "32px",
                                              height: "32px",
                                              border: "none",
                                              borderRadius: "50%",
                                              backgroundColor: options.adult >= 6 ? "#E5E7EB" : "#FBD316",
                                              color: options.adult >= 6 ? "#9CA3AF" : "#003663",
                                              fontSize: "18px",
                                              cursor: options.adult >= 6 ? "not-allowed" : "pointer",
                                              boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              transition: "all 0.2s ease"
                                            }}
                                            onMouseEnter={(e) => {
                                              if (options.adult < 6) {
                                                e.currentTarget.style.backgroundColor = "#e6be14";
                                                e.currentTarget.style.transform = "scale(1.1)";
                                              }
                                            }}
                                            onMouseLeave={(e) => {
                                              if (options.adult < 6) {
                                                e.currentTarget.style.backgroundColor = "#FBD316";
                                                e.currentTarget.style.transform = "scale(1)";
                                              }
                                            }}
                                          >
                                            +
                                          </button>
                                        </div>
                                      </div>
                                      
                                      {/* Children */}
                                      <div style={{ 
                                        display: "flex", 
                                        alignItems: "center", 
                                        justifyContent: "space-between",
                                        marginBottom: "10px",
                                        padding: "8px 0",
                                        backgroundColor: "#FFFFFF",
                                        borderBottom: "1px solid #f0f0f0"
                                      }}>
                                        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                          <div style={{ 
                                            color: "#003663",
                                            backgroundColor: "rgba(0, 54, 99, 0.08)",
                                            width: "32px",
                                            height: "32px",
                                            borderRadius: "50%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                          }}>
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                              <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="currentColor"/>
                                            </svg>
                                          </div>
                                          <div>
                                            <div style={{ 
                                              color: "#003663", 
                                              fontSize: "16px", 
                                              fontWeight: "500",
                                              lineHeight: "1.2"
                                            }}>{translation("children")}</div>
                                            <div style={{ 
                                              color: "#6B7280", 
                                              fontSize: "14px",
                                              lineHeight: "1.2"
                                            }}>{translation("2_to_11_years")}</div>
                                          </div>
                                        </div>
                                        <div style={{ 
                                          display: "flex", 
                                          alignItems: "center", 
                                          gap: "12px" 
                                        }}>
                                          <button
                                            disabled={options.children <= 0}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              e.preventDefault();
                                              handleOption("children", "minus");
                                            }}
                                            style={{
                                              width: "32px",
                                              height: "32px",
                                              border: "none",
                                              borderRadius: "50%",
                                              backgroundColor: options.children <= 0 ? "#E5E7EB" : "#FBD316",
                                              color: options.children <= 0 ? "#9CA3AF" : "#003663",
                                              fontSize: "18px",
                                              cursor: options.children <= 0 ? "not-allowed" : "pointer",
                                              boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              transition: "all 0.2s ease"
                                            }}
                                            onMouseEnter={(e) => {
                                              if (options.children > 0) {
                                                e.currentTarget.style.backgroundColor = "#e6be14";
                                                e.currentTarget.style.transform = "scale(1.1)";
                                              }
                                            }}
                                            onMouseLeave={(e) => {
                                              if (options.children > 0) {
                                                e.currentTarget.style.backgroundColor = "#FBD316";
                                                e.currentTarget.style.transform = "scale(1)";
                                              }
                                            }}
                                          >
                                            -
                                          </button>
                                          <span style={{ 
                                            fontSize: "18px", 
                                            fontWeight: "600",
                                            minWidth: "20px",
                                            textAlign: "center",
                                            color: "#003663"
                                          }}>{options.children}</span>
                                          <button
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              e.preventDefault();
                                              handleOption("children", "plus");
                                            }}
                                            disabled={options.children >= 4}
                                            style={{
                                              width: "32px",
                                              height: "32px",
                                              border: "none",
                                              borderRadius: "50%",
                                              backgroundColor: options.children >= 4 ? "#E5E7EB" : "#FBD316",
                                              color: options.children >= 4 ? "#9CA3AF" : "#003663",
                                              fontSize: "18px",
                                              cursor: options.children >= 4 ? "not-allowed" : "pointer",
                                              boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              transition: "all 0.2s ease"
                                            }}
                                            onMouseEnter={(e) => {
                                              if (options.children < 4) {
                                                e.currentTarget.style.backgroundColor = "#e6be14";
                                                e.currentTarget.style.transform = "scale(1.1)";
                                              }
                                            }}
                                            onMouseLeave={(e) => {
                                              if (options.children < 4) {
                                                e.currentTarget.style.backgroundColor = "#FBD316";
                                                e.currentTarget.style.transform = "scale(1)";
                                              }
                                            }}
                                          >
                                            +
                                          </button>
                                        </div>
                                      </div>
                                      
                                      {/* Babies */}
                                      <div style={{ 
                                        display: "flex", 
                                        alignItems: "center", 
                                        justifyContent: "space-between",
                                        marginBottom: "10px",
                                        padding: "8px 0",
                                        backgroundColor: "#FFFFFF",
                                        borderBottom: "1px solid #f0f0f0"
                                      }}>
                                        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                          <div style={{ 
                                            color: "#003663",
                                            backgroundColor: "rgba(0, 54, 99, 0.08)",
                                            width: "32px",
                                            height: "32px",
                                            borderRadius: "50%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                          }}>
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                              <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="currentColor"/>
                                            </svg>
                                          </div>
                                          <div>
                                            <div style={{ 
                                              color: "#003663", 
                                              fontSize: "16px", 
                                              fontWeight: "500",
                                              lineHeight: "1.2"
                                            }}>{translation("babies")}</div>
                                            <div style={{ 
                                              color: "#6B7280", 
                                              fontSize: "14px",
                                              lineHeight: "1.2"
                                            }}>{translation("under_2_years_old")}</div>
                                          </div>
                                        </div>
                                        <div style={{ 
                                          display: "flex", 
                                          alignItems: "center", 
                                          gap: "12px" 
                                        }}>
                                          <button
                                            disabled={options.babies <= 0}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              e.preventDefault();
                                              handleOption("babies", "minus");
                                            }}
                                            style={{
                                              width: "32px",
                                              height: "32px",
                                              border: "none",
                                              borderRadius: "50%",
                                              backgroundColor: options.babies <= 0 ? "#E5E7EB" : "#FBD316",
                                              color: options.babies <= 0 ? "#9CA3AF" : "#003663",
                                              fontSize: "18px",
                                              cursor: options.babies <= 0 ? "not-allowed" : "pointer",
                                              boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              transition: "all 0.2s ease"
                                            }}
                                            onMouseEnter={(e) => {
                                              if (options.babies > 0) {
                                                e.currentTarget.style.backgroundColor = "#e6be14";
                                                e.currentTarget.style.transform = "scale(1.1)";
                                              }
                                            }}
                                            onMouseLeave={(e) => {
                                              if (options.babies > 0) {
                                                e.currentTarget.style.backgroundColor = "#FBD316";
                                                e.currentTarget.style.transform = "scale(1)";
                                              }
                                            }}
                                          >
                                            -
                                          </button>
                                          <span style={{ 
                                            fontSize: "18px", 
                                            fontWeight: "600",
                                            minWidth: "20px",
                                            textAlign: "center",
                                            color: "#003663"
                                          }}>{options.babies}</span>
                                          <button
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              e.preventDefault();
                                              handleOption("babies", "plus");
                                            }}
                                            disabled={options.babies >= 4}
                                            style={{
                                              width: "32px",
                                              height: "32px",
                                              border: "none",
                                              borderRadius: "50%",
                                              backgroundColor: options.babies >= 4 ? "#E5E7EB" : "#FBD316",
                                              color: options.babies >= 4 ? "#9CA3AF" : "#003663",
                                              fontSize: "18px",
                                              cursor: options.babies >= 4 ? "not-allowed" : "pointer",
                                              boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              transition: "all 0.2s ease"
                                            }}
                                            onMouseEnter={(e) => {
                                              if (options.babies < 4) {
                                                e.currentTarget.style.backgroundColor = "#e6be14";
                                                e.currentTarget.style.transform = "scale(1.1)";
                                              }
                                            }}
                                            onMouseLeave={(e) => {
                                              if (options.babies < 4) {
                                                e.currentTarget.style.backgroundColor = "#FBD316";
                                                e.currentTarget.style.transform = "scale(1)";
                                              }
                                            }}
                                          >
                                            +
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                    
                                    {/* Class selection */}
                                    <div style={{ marginTop: "8px", marginBottom: "8px" }}>
                                      {/* Removed cabin_class header for more compact design */}
                                      {["Economy", "Premium Economy", "Business"].map((classType) => (
                                        <button
                                          key={classType}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            handleClass(classType);
                                            setFilterClass(SELECTED_CLASS[classType]);
                                          }}
                                          style={{
                                            width: "100%",
                                            padding: "12px 24px",
                                            marginBottom: "8px",
                                            border: options.class === classType ? "none" : "1px solid #E5E7EB",
                                            borderRadius: "10px",
                                            backgroundColor: options.class === classType ? "#003663" : "#FFFFFF",
                                            color: options.class === classType ? "#fff" : "#003663",
                                            fontSize: "16px",
                                            fontWeight: "500",
                                            textAlign: "left",
                                            cursor: "pointer",
                                            transition: "all 0.2s ease",
                                            boxShadow: options.class === classType ? "0 2px 4px rgba(0,0,0,0.1)" : "none"
                                          }}
                                          onMouseEnter={(e) => {
                                            if (options.class !== classType) {
                                              e.currentTarget.style.backgroundColor = "rgba(0, 54, 99, 0.05)";
                                              e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.05)";
                                            }
                                          }}
                                          onMouseLeave={(e) => {
                                            if (options.class !== classType) {
                                              e.currentTarget.style.backgroundColor = "#FFFFFF";
                                              e.currentTarget.style.boxShadow = "none";
                                            }
                                          }}
                                        >
                                          {translation(classType)}
                                        </button>
                                      ))}
                                    </div>
                                    
                                    {/* Done button */}
                                    <div style={{ marginTop: "8px", padding: "12px", display: "flex", justifyContent: "center" }}>
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          e.preventDefault();
                                          setTravellerDropDownShow(false);
                                          setblurBackground(false);
                                          setCurrentStep(1); // Reset to first step when done
                                        }}
                                        style={{
                                          marginTop: "4px",
                                          padding: "12px",
                                          backgroundColor: "#FBD316",
                                          color: "#003663",
                                          fontWeight: "600",
                                          fontSize: "16px",
                                          border: "none",
                                          borderRadius: "8px",
                                          cursor: "pointer",
                                          width: "100%",
                                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                          transition: "all 0.2s ease"
                                        }}
                                        onMouseEnter={(e) => {
                                          e.currentTarget.style.backgroundColor = "#e6be14";
                                          e.currentTarget.style.transform = "scale(1.02)";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.backgroundColor = "#FBD316";
                                          e.currentTarget.style.transform = "scale(1)";
                                        }}
                                      >
                                        {translation("done")}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Search button positioned at far right - now at the absolute edge */}
                          <div style={{ 
                            width: '250px',
                            position: 'absolute',
                            right: '-260px', // Changed from -150px to -110px to move further right
                            top: '90px', // moved down by 5 inches (480px) from 85px
                            zIndex: 5
                          }}>
                            <button
                              onClick={() => {
                                handleSearchClick();
                              }}
                              onMouseEnter={() => setIsHovered(true)}
                              onMouseLeave={() => {
                                setIsHovered(false);
                                setIsActive(false);
                              }}
                              onMouseDown={() => setIsActive(true)}
                              onMouseUp={() => setIsActive(false)}
                              style={{
                                ...getDynamicButtonStyle(),
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "8px",
                                fontSize: "18px",
                                fontWeight: "600",
                                marginBottom: "0",
                                transform: isHovered ? "scale(1.05)" : "scale(1)",
                                boxShadow: isHovered ? "0px 6px 12px rgba(0,0,0,0.3)" : "0px 4px 8px rgba(0,0,0,0.2)"
                              }}
                            >
                              Search
                              <img
                                src={require("../assets/img/icon-search.png")}
                                alt="Search"
                                style={{ width: 22, height: 22 }}
                              />
                            </button>
                            

                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* Add blur effect when overlays are shown */}
      <div className="blurr"></div>
      
      {/* Additional mobile view components will be added */}
      
      {(viewDestinationLookup || viewOriginLookup || travellerDropDownShow) && (
        <div className="blurr2"></div>
      )}

      {/* Mobile Implementation */}
      {isMobile && (
        <Fragment>
          {/* Origin Drawer */}
          <Modal isOpen={currentMobileStep === 1 && viewOriginLookup} onClose={() => setViewOriginLookup(false)}>
            <DrawerComponent
              id="origin"
              key="origin"
              open={viewOriginLookup}
              setOpen={setViewOriginLookup}
              headerText={translation && translation("select_origin")}
              anchor="bottom"
              style={{
                height: "100vh",
                width: "100vw",
                margin: 0,
                maxWidth: "100%"
              }}
            >
              <MobileDrawerContent>
                <div className="search-input-container">
                  <input
                    type="text"
                    value={originValue}
                    onChange={handleOriginInputChange}
                    placeholder={translation("search_origin")}
                    style={{
                      width: "100%",
                      padding: "12px 16px",
                      borderRadius: "8px",
                      border: "1px solid #e5e7eb",
                      fontSize: "16px"
                    }}
                  />
                </div>
                <div className="search-results" style={{ flex: 1, overflowY: "auto", marginTop: "16px" }}>
                  <LookupItems
                    items={originSearchResults}
                    onItemClick={(item) => {
                      setOriginValue(item.name);
                      setOriginCode(item.code);
                      setOriginCity(item.city);
                      setViewOriginLookup(false);
                      handleMobileStepChange(2);
                    }}
                  />
                </div>
              </MobileDrawerContent>
            </DrawerComponent>
          </Modal>

          {/* Destination Drawer */}
          <Modal isOpen={currentMobileStep === 2 && viewDestinationLookup} onClose={() => setViewDestinationLookup(false)}>
            <DrawerComponent
              id="destination"
              key="destination"
              open={viewDestinationLookup}
              setOpen={setViewDestinationLookup}
              headerText={translation && translation("select_destination")}
              anchor="bottom"
              style={{
                height: "100vh",
                width: "100vw",
                margin: 0,
                maxWidth: "100%"
              }}
            >
              <MobileDrawerContent>
                <div className="search-input-container">
                  <input
                    type="text"
                    value={destinationValue}
                    onChange={handleDestinationInputChange}
                    placeholder={translation("search_destination")}
                    style={{
                      width: "100%",
                      padding: "12px 16px",
                      borderRadius: "8px",
                      border: "1px solid #e5e7eb",
                      fontSize: "16px"
                    }}
                  />
                </div>
                <div className="search-results" style={{ flex: 1, overflowY: "auto", marginTop: "16px" }}>
                  <LookupItems
                    items={destinationSearchResults}
                    onItemClick={(item) => {
                      setDestinationValue(item.name);
                      setDestinationCode(item.code);
                      setDestinationCity(item.city);
                      setViewDestinationLookup(false);
                      handleMobileStepChange(3);
                    }}
                  />
                </div>
              </MobileDrawerContent>
            </DrawerComponent>
          </Modal>

          {/* Date Picker Drawer */}
          <Modal isOpen={currentMobileStep === 3 && isCalendarOpen} onClose={() => setIsCalendarOpen(false)}>
            <DrawerComponent
              id="date-picker"
              key="date-picker"
              open={isCalendarOpen}
              setOpen={setIsCalendarOpen}
              headerText={translation && translation("select_dates")}
              anchor="bottom"
              style={{
                height: "100vh",
                width: "100vw",
                margin: 0,
                maxWidth: "100%"
              }}
            >
              <div style={{ 
                height: 'calc(100vh - 70px)', 
                display: 'flex', 
                flexDirection: 'column',
                backgroundColor: 'white',
                overflow: 'hidden'
              }}>
                <NewDatePicker
                  key={`mobile-datepicker-${returnOrOneWay}`}
                  isRange={returnOrOneWay === "return"}
                  value={dateRange}
                  onChange={handleDateChange}
                  onDoneClick={handleMobileDateDone}
                  minDate={new Date()}
                  placeholder={translation("select_date")}
                  departurePlaceholder={translation("departure_date")}
                  returnPlaceholder={translation("return_date")}
                  isOpen={true}
                  preventDirectOpen={false}
                  isMobile={true}
                />
              </div>
            </DrawerComponent>
          </Modal>

          {/* Travelers Drawer */}
          <Modal isOpen={currentMobileStep === 4 && travellerDropDownShow} onClose={() => setTravellerDropDownShow(false)}>
            <DrawerComponent
              id="travelers"
              key="travelers"
              open={travellerDropDownShow}
              setOpen={setTravellerDropDownShow}
              headerText={translation && translation("select_travelers")}
              anchor="bottom"
              style={{
                height: "100vh",
                width: "100vw",
                margin: 0,
                maxWidth: "100%"
              }}
            >
              <MobileDrawerContent>
                {/* Adults */}
                <div style={{ 
                  display: "flex", 
                  alignItems: "center", 
                  justifyContent: "space-between",
                  marginBottom: "24px",
                  padding: "8px 0",
                  borderBottom: "1px solid #E5E7EB"
                }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <div style={{ 
                      color: "#003663",
                      backgroundColor: "rgba(0, 54, 99, 0.08)",
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="currentColor"/>
                      </svg>
                    </div>
                    <div>
                      <div style={{ 
                        color: "#003663", 
                        fontSize: "16px", 
                        fontWeight: "500",
                        lineHeight: "1.2"
                      }}>{translation("adults")}</div>
                      <div style={{ 
                        color: "#6B7280", 
                        fontSize: "14px",
                        lineHeight: "1.2"
                      }}>{translation("12_years_and_older")}</div>
                    </div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <button
                      onClick={() => handleOption("adult", "decrease")}
                      disabled={options.adult <= 1}
                      style={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "50%",
                        border: "1px solid #E5E7EB",
                        background: "white",
                        color: "#003663",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "18px"
                      }}
                    >
                      -
                    </button>
                    <span style={{ 
                      minWidth: "24px", 
                      textAlign: "center",
                      color: "#003663",
                      fontSize: "16px",
                      fontWeight: "500"
                    }}>
                      {options.adult}
                    </span>
                    <button
                      onClick={() => handleOption("adult", "increase")}
                      style={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "50%",
                        border: "1px solid #E5E7EB",
                        background: "white",
                        color: "#003663",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "18px"
                      }}
                    >
                      +
                    </button>
                  </div>
                </div>

                {/* Children */}
                <div style={{ 
                  display: "flex", 
                  alignItems: "center", 
                  justifyContent: "space-between",
                  marginBottom: "24px",
                  padding: "8px 0",
                  borderBottom: "1px solid #E5E7EB"
                }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <div style={{ 
                      color: "#003663",
                      backgroundColor: "rgba(0, 54, 99, 0.08)",
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="currentColor"/>
                      </svg>
                    </div>
                    <div>
                      <div style={{ 
                        color: "#003663", 
                        fontSize: "16px", 
                        fontWeight: "500",
                        lineHeight: "1.2"
                      }}>{translation("children")}</div>
                      <div style={{ 
                        color: "#6B7280", 
                        fontSize: "14px",
                        lineHeight: "1.2"
                      }}>{translation("2_to_11_years")}</div>
                    </div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <button
                      onClick={() => handleOption("children", "decrease")}
                      disabled={options.children <= 0}
                      style={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "50%",
                        border: "1px solid #E5E7EB",
                        background: "white",
                        color: "#003663",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "18px"
                      }}
                    >
                      -
                    </button>
                    <span style={{ 
                      minWidth: "24px", 
                      textAlign: "center",
                      color: "#003663",
                      fontSize: "16px",
                      fontWeight: "500"
                    }}>
                      {options.children}
                    </span>
                    <button
                      onClick={() => handleOption("children", "increase")}
                      style={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "50%",
                        border: "1px solid #E5E7EB",
                        background: "white",
                        color: "#003663",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "18px"
                      }}
                    >
                      +
                    </button>
                  </div>
                </div>

                {/* Babies */}
                <div style={{ 
                  display: "flex", 
                  alignItems: "center", 
                  justifyContent: "space-between",
                  marginBottom: "24px",
                  padding: "8px 0",
                  borderBottom: "1px solid #E5E7EB"
                }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <div style={{ 
                      color: "#003663",
                      backgroundColor: "rgba(0, 54, 99, 0.08)",
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="currentColor"/>
                      </svg>
                    </div>
                    <div>
                      <div style={{ 
                        color: "#003663", 
                        fontSize: "16px", 
                        fontWeight: "500",
                        lineHeight: "1.2"
                      }}>{translation("babies")}</div>
                      <div style={{ 
                        color: "#6B7280", 
                        fontSize: "14px",
                        lineHeight: "1.2"
                      }}>{translation("under_2_years_old")}</div>
                    </div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <button
                      onClick={() => handleOption("babies", "decrease")}
                      disabled={options.babies <= 0}
                      style={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "50%",
                        border: "1px solid #E5E7EB",
                        background: "white",
                        color: "#003663",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "18px"
                      }}
                    >
                      -
                    </button>
                    <span style={{ 
                      minWidth: "24px", 
                      textAlign: "center",
                      color: "#003663",
                      fontSize: "16px",
                      fontWeight: "500"
                    }}>
                      {options.babies}
                    </span>
                    <button
                      onClick={() => handleOption("babies", "increase")}
                      style={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "50%",
                        border: "1px solid #E5E7EB",
                        background: "white",
                        color: "#003663",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "18px"
                      }}
                    >
                      +
                    </button>
                  </div>
                </div>

                {/* Class Selection */}
                <div style={{ marginBottom: "24px" }}>
                  <div style={{ 
                    color: "#003663", 
                    fontSize: "16px", 
                    fontWeight: "500",
                    marginBottom: "12px"
                  }}>
                    {translation("class")}
                  </div>
                  <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                    {Object.entries(SELECTED_CLASS).map(([key, value]) => (
                      <button
                        key={key}
                        onClick={() => handleClass(key)}
                        style={{
                          padding: "8px 16px",
                          borderRadius: "8px",
                          border: "1px solid #E5E7EB",
                          background: selectedClassState === key ? "#003663" : "white",
                          color: selectedClassState === key ? "white" : "#003663",
                          cursor: "pointer",
                          fontSize: "14px",
                          fontWeight: "500"
                        }}
                      >
                        {value}
                      </button>
                    ))}
                  </div>
                </div>

                <MobileSearchButton onClick={() => {
                  setTravellerDropDownShow(false);
                  handleMobileStepChange(1);
                }}>
                  {translation("apply")}
                </MobileSearchButton>
              </MobileDrawerContent>
            </DrawerComponent>
          </Modal>
        </Fragment>
      )}
      
      {/* Cookie Consent Banner */}
      <CookieConsent />
    </section>
  );
};

export default Banner; 